// 平均派单时长  平均响应时长   管理员们派单占比，派单平均时长  维保人员们响应占比(饼状图)，响应平均时长(多柱状图)    派单表格(员工名称/日期/日期/日期/日期 /总计)
<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-rank"></i> 绩效考核 </el-breadcrumb-item>
                <el-breadcrumb-item>维保人员</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="dataPicker">
                <el-date-picker
                    v-model="value2"
                    type="daterange"
                    align="center"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                ></el-date-picker>
                <el-button type="success" class="btn1">搜索</el-button>
                <el-button type="primary">刷新</el-button>
            </div>

            <div class="lineS" ref="handleOrderLine"></div>

            <!-- 维保人员 -->
            <div class="botCharts">
                <div class="leftS" ref="userPie"></div>
                <div class="rightS" ref="userCat"></div>
            </div>

            <el-button type="primary">导出表格</el-button>

            <el-table class="elTable" :data="tableData" border style="width: 100%">
                <el-table-column prop="date" label="日期" align="center"></el-table-column>
                <el-table-column label="雷龙龙" align="center">
                    <el-table-column label="响应数量/个" prop="s1" align="center"></el-table-column>
                    <el-table-column label="响应时长/分钟" prop="s2" align="center"></el-table-column>
                </el-table-column>
                <el-table-column label="宁衡正" align="center">
                    <el-table-column label="响应数量/个" prop="s3" align="center"></el-table-column>
                    <el-table-column label="响应时长/分钟" prop="s4" align="center"></el-table-column>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
// import { fetchData } from '../../api/index';
import * as echarts from 'echarts';
export default {
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            value1: '',
            value2: '',
            tableData: [
                {
                    date: '2022-08-22',
                    s1: 20,
                    s2: 2,
                    s3: 30,
                    s4: 3
                },
                {
                    date: '2022-08-23',
                    s1: 20,
                    s2: 1,
                    s3: 30,
                    s4: 3
                },
                {
                    date: '2022-08-24',
                    s1: 20,
                    s2: 5,
                    s3: 30,
                    s4: 1
                },
                {
                    date: '2022-08-25',
                    s1: 20,
                    s2: 4,
                    s3: 30,
                    s4: 1
                },
                {
                    date: '2022-08-26',
                    s1: 20,
                    s2: 5,
                    s3: 30,
                    s4: 1
                },
                {
                    date: '2022-08-27',
                    s1: 20,
                    s2: 5,
                    s3: 30,
                    s4: 1
                },
                {
                    date: '2022-08-28',
                    s1: 20,
                    s2: 4,
                    s3: 30,
                    s4: 1
                }
            ]
        };
    },
    mounted() {
        setTimeout(() => {
            // 绘制平均响应时长分析曲线图
            let handleOrder = this.$echarts.init(this.$refs.handleOrderLine);
            handleOrder.setOption({
                title: {
                    text: '平均响应时长',
                    subtext: '维保人员接收到工单时,处理工单所需时间 单位/分钟'
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top: '20%',
                    left: '5%',
                    bottom: '10%',
                    containLabel: false
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['2022-08-22', '2022-08-23', '2022-08-24', '2022-08-25', '2022-08-26', '2022-08-27', '2022-08-28']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '平时时长',
                        type: 'line',
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    { offset: 0, color: '#ee6666' },
                                    { offset: 0.5, color: '#fac858' },
                                    { offset: 1, color: '#91cc75' }
                                ])
                            }
                        },
                        lineStyle: {
                            color: '#91cc75'
                        },
                        itemStyle: {
                            opacity: 0
                        },
                        data: [40, 50, 11, 33, 25, 0, 15]
                    }
                ]
            });

            // 绘制维保人员处理占比饼状图
            let userPie = this.$echarts.init(this.$refs.userPie);
            userPie.setOption({
                title: {
                    text: '维保人员响应占比',
                    left: 'left'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    bottom: 'bottom'
                },
                series: [
                    {
                        name: '姓名',
                        type: 'pie',
                        radius: '50%',
                        data: [
                            { value: 1048, name: '雷龙龙' },
                            { value: 735, name: '宁衡正' }
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });

            // 绘制维保人员平均时长柱状图
            let userCat = this.$echarts.init(this.$refs.userCat);
            userCat.setOption({
                title: {
                    text: '维保人员响应平均时长',
                    left: 'left'
                },
                grid: {
                    bottom: 25
                },
                tooltip: {},
                legend: {},
                xAxis: {
                    data: ['2022-08-22', '2022-08-23', '2022-08-24', '2022-08-25', '2022-08-26', '2022-08-27', '2022-08-28']
                },
                yAxis: {},
                series: [
                    {
                        name: '雷龙龙',
                        type: 'bar',
                        data: [5, 26, 36, 10, 10, 54, 4]
                    },
                    {
                        name: '宁衡正',
                        type: 'bar',
                        data: [8, 20, 21, 4, 53, 20, 3]
                    }
                ]
            });
        }, 10);
    },
    created() {},
    methods: {}
};
</script>

<style lang="less" scoped>
.lineS {
    width: 100%;
    height: 400px;
}
.botCharts {
    margin-top: 20px;
    width: 100%;
    height: 400px;
    display: flex;
}
.leftS {
    width: 40%;
    height: 400px;
}
.rightS {
    width: 60%;
    height: 400px;
}
.dataPicker {
    display: flex;
    font-size: 0.5rem;
    align-items: center;
    height: 1rem;
    .btn1 {
        margin-left: 20px;
    }
}
.elTable {
    margin-top: 20px;
}
</style>


